/** * @file PhoneNumberInput */
<template>
  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
    <el-col :span="4" class="u-w--120">
      <el-input
        type="tel"
        placeholder=""
        maxlength="5"
        :name="phoneName1"
        @blur="phoneBlur1"
        v-model="phoneModel1"
        :data-validator-name="phoneNameValidationName1"
        :disabled="disabled"
      />
    </el-col>
    <el-col :span="1" class="u-w--15">-</el-col>
    <el-col :span="4" class="u-w--120">
      <el-input
        type="tel"
        placeholder=""
        maxlength="5"
        :name="phoneName2"
        @blur="phoneBlur2"
        v-model="phoneModel2"
        :data-validator-name="phoneNameValidationName2"
        :disabled="disabled"
      />
    </el-col>
    <el-col :span="1" class="u-w--15">-</el-col>
    <el-col :span="4" class="u-w--120">
      <el-input
        type="tel"
        placeholder=""
        maxlength="5"
        :name="phoneName3"
        @blur="phoneBlur3"
        v-model="phoneModel3"
        :data-validator-name="phoneNameValidationName3"
        :disabled="disabled"
      />
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    phoneName1: {
      type: String,
      default: null
    },
    phoneModelVal1: {
      type: String,
      default: null
    },
    phoneBlur1: {
      type: Function,
      default: () => {}
    },
    phoneNameValidationName1: {
      type: String,
      default: null
    },
    phoneName2: {
      type: String,
      default: null
    },
    phoneModelVal2: {
      type: String,
      default: null
    },
    phoneBlur2: {
      type: Function,
      default: () => {}
    },
    phoneNameValidationName2: {
      type: String,
      default: null
    },
    phoneName3: {
      type: String,
      default: null
    },
    phoneModelVal3: {
      type: String,
      default: null
    },
    phoneBlur3: {
      type: Function,
      default: () => {}
    },
    phoneNameValidationName3: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    phoneModel1: {
      get() {
        return this.phoneModelVal1
      },
      set(val) {
        this.$emit('update:phoneModelVal1', val)
      }
    },
    phoneModel2: {
      get() {
        return this.phoneModelVal2
      },
      set(val) {
        this.$emit('update:phoneModelVal2', val)
      }
    },
    phoneModel3: {
      get() {
        return this.phoneModelVal3
      },
      set(val) {
        this.$emit('update:phoneModelVal3', val)
      }
    }
  }
}
</script>
